import { Table as AntTable } from 'antd'
import type { TableProps } from 'antd'
import { SIZE_MAP } from '../types'
import type { Size } from '../types'

export interface AppTableProps<T = any> extends Omit<TableProps<T>, 'size'> {
  size?: Size
}

export const AppTable = <T extends object = any>({ size = 'md', ...rest }: AppTableProps<T>) => (
  <AntTable<T> size={SIZE_MAP[size]} {...rest} />
)
